import React, {
  FC,
  useState,
  useRef,
  useEffect,
  useCallback,
} from "react";
import "./transparentSearchBar.scss";

type TransparentSearchBarProps = {
  version?: number;
  top?: string;
  mobile?: boolean;
};

const TransparentSearchBar: FC<TransparentSearchBarProps> = ({
  version,
  top,
  mobile = false,
}) => {
  const defaultClassName = "transparent-search-bar";
  const mobileClassName = "transparent-search-bar mobile";
  const [className, setClassName] = useState(
    mobile ? `${mobileClassName} hide-iframe` : `${defaultClassName} hide-iframe`
  );

  const [shouldLoad, setShouldLoad] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handleClassName = (isHidden: boolean) => {
    const classType = mobile ? mobileClassName : defaultClassName;
    isHidden
      ? setClassName(`hide-iframe ${classType}`)
      : setClassName(classType);
  };

  const checkInView = useCallback(() => {
    if (!iframeRef.current) return;
    const rect = iframeRef.current.getBoundingClientRect();
    const inView = rect.top < window.innerHeight && rect.bottom > 0;
    if (inView) setShouldLoad(true);
  }, []);

  useEffect(() => {
    let timer: number;
    function handleScroll() {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(checkInView, 100);
    }
    window.addEventListener("scroll", handleScroll);
    checkInView();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (timer) window.clearTimeout(timer);
    };
  }, [checkInView]);

  return (
    <iframe
      ref={iframeRef}
      className={className}
      style={{ top }}
      scrolling="no"
      onMouseEnter={() => handleClassName(false)}
      onMouseLeave={() => handleClassName(true)}
      src={
        shouldLoad
          ? version
            ? `https://transparencyresources.idaho.gov/customsearch/${version}`
            : "https://transparencyresources.idaho.gov/customsearch"
          : undefined
      }
    />
  );
};

export default TransparentSearchBar;
